import React, { Component } from 'react'
import { Action } from 'hljd'
import { hashHistory } from 'react-router'
import {
  STUFF_ACCOUNT_MANAGE_PATH,
  PRIVILEGE_STORE_SERVICE_ID,
  SELLERSERVICE_PATH,
  SETTLEMENTACCOUNT_PATH
} from '@constant'
import { WithCommon } from '../Common'
import { getAuthId } from '@util'

export default WithCommon(
  class extends Component {
    constructor(props) {
      super(props)
      this.state = {
        active: undefined,
        options: []
      }
    }

    getOptions = () => {
      let options = [
        { title: '绑定微信号', value: '3', link: SELLERSERVICE_PATH }
      ]
      // 加盟店客服账号没有这些菜单
      if (getAuthId() != PRIVILEGE_STORE_SERVICE_ID) {
        options = options.concat([
          { title: '结算账户', value: '4', link: SETTLEMENTACCOUNT_PATH },
          { title: '私信客服管理', value: '2', link: STUFF_ACCOUNT_MANAGE_PATH }
        ])
      }
      return options
    }

    componentDidMount() {
      const pathname = this.props.location.pathname
      const options = this.getOptions()
      const active = (
        options.find(item => item.link && item.link.includes(pathname)) || {}
      ).value
      this.setState({ active, options })
    }

    render() {
      const { active, options } = this.state
      return (
        <Action
          active={active}
          options={options}
          bordered={false}
          onChange={value => {
            hashHistory.push(options.find(item => item.value == value).link)
          }}
        />
      )
    }
  }
)
